import React, { useState, useEffect } from 'react';
import R from 'ramda';

import { useDispatch, useSelector } from 'react-redux';

export default function DateField({ id, updateValue, required, label, autoFocus, placeholder, name, classes, defaultValue = '' }) {
    const { answers } = useSelector(R.pick(['answers']));

    const [value, setValue] = useState(defaultValue);

    useEffect(() => {
        if (answers?.find(q => q.qID == id)) {
            setValue(answers.find(q => q.qID == id).answer);
        }
    }, [])

    useEffect(() => {
        if (answers?.find(q => q.qID == id)) {
            setValue(answers.find(q => q.qID == id).answer);
        }
    }, [answers])

    const onChange = e => {
        const value = e.target.value;

        setValue(value);
        updateValue(id, value);
    }

    return (
        <div className="form-group">
            <label>{label}{required && <span className="required">*</span>}</label>
            <input type="date" className={classes.join(" ")} id={id} autoFocus={autoFocus} onChange={onChange} value={value} placeholder={placeholder} name={name} />
        </div>
    )
}